<template>
  <div>
    <section class="content-detail shadow-sm">
      <div v-if="detail.image_url">
        <img :src="detail.image_url" class="w-100" />
      </div>
      <div v-else>
        <img :src="img" class="w-100" />
      </div>
      <div class="p-2" style="background-color: #3a3a3a">
        <div class="title-detail line-clamp-2">
          {{ detail.name }}
        </div>
        <b-row>
          <b-col cols="7">
            <div class="valide-until"  v-if="$store.state.theme.line_display_redeem_expire == '1'">
              แลกได้ถึง: {{ dateFormat(detail.valid_to) }}
            </div>
          </b-col>
          <b-col cols="5">
            <div v-if="detail.out_of_stock" class="status-false">
              ของรางวัลหมด
            </div>
            <div class="receive-point">ใช้ {{ detail.point_used }} คะแนน</div>
          </b-col>
        </b-row>
      </div>
      <div class="panel-desc">
        <!-- <div class="p-3"> -->
        <template v-if="$store.state.theme.is_center_point == '1'">
          <div class="d-inline-flex w-100">
            <div>คะแนนสะสมปัจจุบัน</div>
            <div class="ml-auto">{{ totalPoint | numeral("0,0") }} คะแนน</div>
          </div>
          <div class="d-inline-flex w-100">
            <div>จำนวนสินค้าที่แลก</div>
            <div class="ml-auto d-inline-flex align-items-center">
              <b-button
                variant="custom-link"
                :disabled="detail.redeemable === 'N' || redeemQty == 1"
                @click="redeemQty -= 1"
              >
                <font-awesome-icon
                  icon="minus-circle"
                  :style="{ color: $store.state.theme.font_color }"
              /></b-button>
              <div class="qty">{{ redeemQty }}</div>

              <b-button
                variant="custom-link"
                :disabled="
                  detail.redeemable === 'N' ||
                  redeemQty >= detail.total_redeemable ||
                  detail.point_used * (redeemQty + 1) > totalPoint
                "
                @click="addQty()"
              >
                <font-awesome-icon
                  icon="plus-circle"
                  :style="{ color: $store.state.theme.font_color }"
                />
              </b-button>
              <br />
            </div>
          </div>

          <div class="d-inline-flex w-100">
            <div>จำนวนคะแนนที่ใช้</div>
            <div class="ml-auto">
              {{ (detail.point_used * redeemQty) | numeral("0,0") }} คะแนน
            </div>
          </div>
          <div class="d-inline-flex w-100">
            <div>คะแนนคงเหลือ</div>
            <div class="ml-auto">
              {{
                (totalPoint - detail.point_used * redeemQty) | numeral("0,0")
              }}
              คะแนน
            </div>
          </div>

          <!-- </div> -->
          <div class="text-right">
            <small class="text-danger f-xs"
              >คงเหลือ {{ detail.total_redeemable }} ชิ้น</small
            >
          </div>
          <hr />
        </template>
        <h6>รายละเอียด</h6>
        <div
          class="px-2"
          v-html="detail.description"
          @click="handleClick"
          v-if="detail.description"
        />
        <div class="text-center mb-2" v-else>ไม่มีรายละเอียด</div>
      </div>
    </section>

    <Footer
      v-if="
        !(this.$route.query.page == 'history' && this.$route.query.type == 1)
      "
      @onClick="handleConfirmRedeem"
      :isDisable="
        detail.redeemable === 'N' ||
        detail.out_of_stock ||
        (this.$route.query.page == 'history' && detail.is_redeem == 1)
      "
      :text="textButton()"
    />

    <ModalRedeem
      ref="modalRedeem"
      :detail="detail"
      @confirmRedeem="handleConfirmRedeem"
    />
    <ModalRedeemAdress
      ref="modalRedeemAddress"
      :desciptionMsg="desciptionMsg"
      :btnMsg="btnMsg"
      :titleMsg="titleMsg"
      @submitModal="handleAddressFill"
    />
    <ModalRedeemPoint
      ref="modalRedeemPoint"
      :detail="detail"
      :totalPoint="totalPoint + branchPoint"
      :address="addressList"
      :redeemQty="redeemQty"
      @redeemSuccess="redeemSuccess"
      @confirm="handleModalPointClick"
      @showLoading="showLoading"
      @hideLoading="hideLoading"
      @redeemError="redeemError"
    />
    <ModalSelectBranch
      ref="ModalSelectBranch"
      :branch="branch"
      @success="success"
      @error="error"
      :detail="detail"
      :redeemQty="redeemQty"
      @showPointUsedModal="showPointUsedModal"
      @showLoading="showLoading"
      @hideLoading="hideLoading"
      @onBranchChange="onBranchChange"
    />
    <ModalAlert ref="modalAlert" :text="msg" @hide="refreshPage" />
    <ModalError ref="modalError" :text="msg" />
    <ModalLoading ref="modalLoading" />
  </div>
</template>

<script>
import ModalRedeem from "@/components/reward/modal/ModalRedeem";
import ModalRedeemAdress from "@/components/reward/modal/ModalRedeemAdress";
import ModalSelectBranch from "@/components/reward/modal/ModalSelectBranch";
import ModalRedeemPoint from "@/components/reward/modal/ModalRedeemPoint";
import ModalAlert from "@/components/alert-modal/ModalAlert";
import ModalLoading from "@/components/other/ModalLoading.vue";
import ModalError from "@/components/alert-modal/ModalError";
import picture from "@/assets/images/default-image.png";
import moment from "moment";
export default {
  components: {
    ModalRedeem,
    ModalAlert,
    ModalError,
    ModalSelectBranch,
    ModalRedeemAdress,
    ModalRedeemPoint,
    ModalLoading
  },
  props: {
    detail: {
      required: true,
      type: Object
    },
    branch: {
      required: true,
      type: Array
    },
    addressFlag: {
      required: true,
      type: Boolean
    },
    id: {
      required: true,
      type: Number
    },
    totalPoint: {
      required: true,
      type: Number
    },
    addressList: {
      required: true,
      type: Object
    },
    buttonName: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      img: picture,
      msg: "",
      typeRedeem: 2,
      desciptionMsg: "",
      btnMsg: "",
      titleMsg: "",
      disabled: false,
      redeemQty: 1,
      branchPoint: 0
    };
  },
  computed: {
    point() {
      return this.$store.state.shortProfile.total_point;
    }
  },
  mounted() {
    if (this.$route.query.edit) {
      this.redeemQty = this.$route.query.qty;
      this.$router.replace(
        `/reward/${this.id}?type=${this.$route.query.type}&o_id=0`
      );
      setTimeout(() => {
        this.$refs.modalRedeemPoint.show(true);
      }, 500);
    }
  },
  methods: {
    handleConfirmRedeem() {
      if (this.$route.query.page == "history" && this.detail.is_redeem == 0) {
        return this.$router.push("/privilege?title=สิทธิพิเศษ");
      } else {
        return this.confirmRedeem();
      }
    },
    textButton() {
      if (this.$route.query.page == "history" && this.detail.is_redeem == 0) {
        return "ไปยังหน้าใช้งานคูปอง";
      } else {
        return this.$route.query.page == "history" && this.detail.is_redeem == 1
          ? "คูปองถูกใช้แล้ว"
          : this.buttonName || "แลกรับของขวัญ";
      }
    },
    dateFormat(date) {
      return moment(date).locale("th").format("lll").replace("เวลา", "");
    },

    handleClick(e) {
      if (e.target.id == "handle-click") {
        this.$liff
          .sendMessages(JSON.parse(e.target.getAttribute("data-message")))
          .then(() => {
            console.log("message sent");
            this.$liff.closeWindow();
          })
          .catch(err => {
            console.log("error", err);
          });
      }
    },
    confirmRedeem() {
      if (
        (this.branch.length == 1 && this.detail.pick_up_type_id == 1) ||
        this.detail.pick_up_type_id == 3
      )
        this.$refs.ModalSelectBranch.confirmRedeem();
      else if (this.detail.pick_up_type_id == 2) {
        if (this.addressFlag) {
          this.$refs.modalRedeemPoint.show(true);
        } else {
          this.desciptionMsg =
            "ของรางวัลจะจัดส่งทางไปรษณีย์ กรุณาตรวจสอบ/กรอกข้อมูลให้ครบถ้วน";
          this.btnMsg = "ถัดไป";
          this.$refs.modalRedeemAddress.show(true);
        }
      } else this.$refs.ModalSelectBranch.show(true);
    },
    showPointUsedModal() {
      this.$refs.modalRedeemPoint.show(true);
    },
    handleModalPointClick() {
      this.$refs.ModalSelectBranch.confirmRedeem();
    },
    refreshPage() {
      this.$router.replace("/reward");
    },
    success(value) {
      this.msg = value;
      this.$refs.modalAlert.show(true);
    },
    error(value) {
      this.msg = value;
      this.$refs.modalError.show(true);
    },
    handleAddressFill() {
      if (this.addressFlag) {
        this.$router.push("/reward");
      } else {
        this.$router.push(
          `/editaddress/${this.id}?type=${this.$route.query.type}&o_id=0&qty=${this.redeemQty}`
        );
      }
    },
    showLoading() {
      this.$refs.modalLoading.show();
    },
    hideLoading() {
      this.$refs.modalLoading.hide();
    },
    redeemSuccess() {
      this.desciptionMsg =
        "ขอบคุณสำหรับการแลกของรางวัล กรุณารอรับสินค้าตามที่อยู่ที่ได้ลงทะเบียนในระบบ";
      this.btnMsg = "กลับหน้าหลัก";
      this.titleMsg = "แลกของรางวัลเสร็จสิ้น";
      this.$refs.modalRedeemAddress.show(true);
    },
    redeemError(data) {
      this.msg = data.detail;
      this.$refs.modalError.show(true);
    },
    addQty() {
      if (this.redeemQty >= this.detail.total_redeemable) return;
      this.redeemQty += 1;
    },
    onBranchChange(val) {
      const point = this.branch.find(el => el.id == val);

      this.branchPoint = point ? point.point : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.status-reward {
  color: lightgreen;
  font-weight: 600;
  font-size: var(--text-md);
  text-align: right;
}
.status-false {
  color: red;
  font-weight: 600;
  font-size: var(--text-md);
  text-align: right;
}

.line-clamp-2 {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

.receive-point {
  color: #fff;
  text-align: right;
  font-size: var(--text-sm);
}

::v-deep a {
  color: gray;
}
::v-deep li.nav-item {
  width: 50%;
  text-align: center;
}
.footer-bottom {
  position: relative;
}
.btn-redeem {
  position: fixed;
  width: 90%;
  bottom: 10px;
  left: 20px;
  right: 10px;
  border: none;
  background-color: #000;
  color: #fff;
  padding: 10px 0;
}

.btn-gray {
  background: #000;
  border-color: transparent;
  color: #fff;
}

.sub-description {
  padding: 10px;
  border-bottom: 1px solid gray;
  font-weight: 600;
}
::v-deep p img {
  width: 100% !important;
  height: auto !important;
}
::v-deep img {
  width: 100% !important;
  height: auto !important;
}
::v-deep table {
  width: 100% !important;
  height: auto !important;
}
::v-deep tr {
  height: auto !important;
}
::v-deep td {
  height: auto !important;
}
.qty {
  width: 30px;
  text-align: center;
}
</style>
